import { useForm } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import toast from 'react-hot-toast';

import { cambiarContraseña } from '../../Services/ForgetPassword';

import atrasIcon from '../../Shared/Images/atras-icon.png';

import '../Styles/ChangePassword.css';


interface FormChangePassword {
  Clave: string;
  ClaveNueva: string;
  ClaveNuevaConfirmed: string;
}

interface Usuario {
  clave: string;
  correo: string;
  nombres: string;
  objetivo: string;
  respondio: boolean;
  usuarioTestAsesoriaID: number;
}

interface Props {
  usuarioTestAsesoriaID: number;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

function AfterVerication({ usuarioTestAsesoriaID, isOpen, setIsOpen }: Props) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const handleChangePassword = (data: FormChangePassword) => {
    cambiarContraseña({
      usuarioTestAsesoriaID,
      ClaveNueva: data.ClaveNueva,
    })
      .then((response) => {
        if (response.data.status === 200) {
          toast.success('Contraseña cambiada con éxito');
          setIsOpen(false);
          navigate('/');
        }
      })
      .catch(() => {
        toast.error('No se ha podido cambiar la contraseña, por favor intenta de nuevo');
      });
  };

  if (user) {
    navigate('/');
  }

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      // className="sm:pt-4 sm:px-4 md:w-[50%] md:m-auto md:mt-20 p-4"
      fullScreen
    >
      <DialogContent className="mt-3 lg:w-[70%] m-auto">
        <div
          className="flex align-items-center"
          style={{
            gap: '1rem',
            // paddingLeft: matches ? '0' : '5rem',
            marginBottom: '1.5rem',
            cursor: 'pointer',
            width: '100%',
          }}
          onClick={() => setIsOpen(false)}
        >
          <img src={atrasIcon} style={{ width: '35px', height: '25px' }} />
        </div>
        <section className="text-left flex flex-col gap-2 mb-4 mt-5">
          <p className="font-bold text-lg m-0">Cambiar Contraseña</p>
          <p className="m-0">
            Ingresa aquí tu antigua contraseña y luego la contraseña que desees como
            nueva.
          </p>
        </section>

        <section className="flex flex-col gap-4 w-full mt-4">
          <TextField
            label="Nueva contraseña"
            variant="outlined"
            type="password"
            className="textarea"
            {...register('ClaveNueva', {
              required: 'Este campo es requerido',
            })}
            required
          />
          <TextField
            label="Confirmar contraseña"
            variant="outlined"
            type="password"
            className="textarea"
            {...register('ClaveNuevaConfirmed', {
              required: 'Este campo es requerido',
            })}
            required
          />
        </section>
        <section>
          <div className="divide-x-0 w-full border mt-4" />
          <p className="text-gray-400 text-sm mt-2">
            Por favor, elige una contraseña segura y fuerte. Usar letras mayúsculas,
            minúsculas, números y caracteres especiales aumentará la seguridad.
          </p>
        </section>
        <div className="w-full flex items-center justify-center">
          <button
            className="px-5 py-2 rounded-full bg-yellow-400 font-bold text-sm mt-4 mb-2  cursor-pointer"
            onClick={handleSubmit(handleChangePassword)}
          >
            Guardar nueva contraseña
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default AfterVerication;
